import { OrderButton } from "features/menu/components/OrderButton";
import { PinkyRectangle } from "shared/components/atoms/PinkyRectangle";
import { usePrice } from "shared/features/shared/usePrice";
import { numberToCurrency } from "shared/utils/numberToCurrency";
import { useMenuContext } from "../hooks/useMenuContext";
import tw from "twin.macro";
import { FreeUsage } from "shared/features/Menu/components/FreeUsage";
import { useCampaignCoupon } from "features/shared/hooks/useCampaignCoupon";

interface Props {
  className?: string;
}

export const InnerOrderButton = ({ className }: Props) => {
  const { menu } = useMenuContext();
  const { getOriginalPrice } = usePrice();
  const { selectAvailableCouponsFor } = useCampaignCoupon();

  const availableCoupons = selectAvailableCouponsFor(menu?.fortuneTeller);
  const isTelMenu = menu?.type === "tel";
  const hasAvailableCoupons = isTelMenu && availableCoupons.length > 0;

  const originPrice = getOriginalPrice(menu);

  return (
    <PinkyRectangle tw="px-5" className={className}>
      <div tw="flex flex-col items-center">
        <div tw="font-base text-lg tracking-[.53px]">鑑定料</div>
        {hasAvailableCoupons && (
          <FreeUsage tw="my-4 ml-20" css={{ transform: "scale(1.5)" }} />
        )}
        <div tw="font-base text-xl leading-5 text-theme">
          <span css={hasAvailableCoupons && tw`line-through`}>
            {numberToCurrency(originPrice)}
            {isTelMenu && " / 分"}
          </span>
          <span tw="font-base font-normal text-sm leading-[14px]">
            （税込）
          </span>
        </div>
      </div>
      <div tw="w-full mt-5">
        <OrderButton tw="w-full" menu={menu} />
      </div>
    </PinkyRectangle>
  );
};
